import React, { useCallback, useEffect, useState, forwardRef } from 'react';
import { styled } from '@mui/joy/styles';
import Grid from '@mui/joy/Grid';
import Sheet from '@mui/joy/Sheet';
import Box from '@mui/joy/Box';
import Autocomplete from '@mui/joy/Autocomplete';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import Input from '@mui/joy/Input';
import IconTrash from '../../assets/icons/trash.svg'
import IconButton from '@mui/joy/IconButton';
import IconPlus from '../../assets/icons/Plus.svg'
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import EditIcon from '@mui/icons-material/Edit';



//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';




//////////////////////// API
import { getContentSocials, createContentSocials, updateContentSocials, deleteContentSocials } from '../../Api/Content';


const schema = yup.object({
    socials: yup.array(yup.object({
        social: yup.string().required("هذا الحقل مطلوب"),
        link: yup.string().required("هذا الحقل مطلوب"),
    }))
})



const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



export default function SocialMediaLinks() {
    // const [totalStatistics, setTotalStatistics] = useState([])
    const [loading, setLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            socials: [],
            social: '',
            link: '',
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue, trigger, getValues, watch, clearErrors } = form;
    const { errors } = formState
    const socials = watch('socials')

    // const top100Films = [
    //     { label: 'Facebook' },
    //     { label: 'Twitter' },
    //     { label: 'Linkedin' },
    //     { label: 'Snapchat' },
    // ];

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpenAlert(false);
      };
    
      const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpenAlertError(false);
      };
    


    const getAllSocials = useCallback(async () => {
        const res = await getContentSocials();
        if (!res) {
            return
        }
        setValue('socials', res)
    }, [])

    const openNewSocials = () => {

        setValue('socials', [...socials, {}])
        clearErrors()
    }


    const deleteSocials = async (id, index) => {
        // const updatedTotalStatistics = [
        //     ...totalStatistics.slice(0, index),
        //     ...totalStatistics.slice(index + 1)
        // ];
        // setTotalStatistics(updatedTotalStatistics);
        if (socials.at(index).id) {
            const res = await deleteContentSocials(id);
            if (res) {
              setMessageAlert('تم الحذف بنجاح')
              setOpenAlert(true)
              getAllSocials();
            }
        } else {
            const updatedSocials = [
                ...socials.slice(0, index),
                ...socials.slice(index + 1)
            ];
            setValue('socials', updatedSocials)
        }
    };

    const checkEditSocials = async (index) => {
        const res = await trigger()
        if (res) {
            setValue(`socials.${index}.social`, socials.at(index).social)
            setValue(`socials.${index}.link`, socials.at(index).link)
            const resApi = await updateContentSocials(socials.at(index).id, socials.at(index))
            if (resApi) {
                setMessageAlert('تم التعديل بنجاح')
                setOpenAlert(true)
                getAllSocials();
            }
        }
    }

    const checkCreateSocials = async (index) => {
        const res = await trigger()
        if (res) {
            setValue(`socials.${index}.social`, socials.at(index).social)
            setValue(`socials.${index}.link`, socials.at(index).link)
            const resApi = await createContentSocials(socials.at(index))
            if (resApi) {
                setMessageAlert('تم الاضافة بنجاح')
                setOpenAlert(true)
                getAllSocials();
            }
        }
    };

    useEffect(() => {
        getAllSocials()
    }, [getAllSocials])

    return (
        <>

            {/* Alert Message */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>


            {/* Socials Media Data */}
            {socials.map((social, index) => {
                return (
                    <Grid
                        container
                        rowSpacing={1}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                        alignItems='center'
                        sx={{ width: '100%' }}
                        key={index}
                    >
                        <Grid xs={9}>
                            <Box component="section" sx={{ display: 'flex', justifyContent: 'space-between' }}>

                                <FormControl sx={{ width: '45%' }}>
                                    <FormLabel>اختر الموقع</FormLabel>
                                    <Input
                                        placeholder="www.facebook.com/soomha"
                                        sx={{ borderRadius: '20px' }}
                                        value={social.social}
                                        {...register(`socials.${index}.social`)}
                                    />

                                    {/* <Autocomplete
                                  placeholder="اختر الموقع"
                                  options={top100Films}
                                  sx={{ width: 300 }}
                              /> */}
                                    {/* <FormHelperText>This is a helper text.</FormHelperText> */}
                                </FormControl>
                                <FormControl sx={{ width: '45%' }}>
                                    <FormLabel>رابط الموقع</FormLabel>
                                    <Input
                                        placeholder="www.facebook.com/soomha"
                                        sx={{ borderRadius: '20px' }}
                                        value={social.link}
                                        {...register(`socials.${index}.link`)}
                                    />
                                </FormControl>
                            </Box>
                        </Grid>
                        <Grid xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', height: '40px' }}>
                            {socials.length - 1 == index && social.id && (
                                <IconButton variant='plain' sx={{ height: '40px' }} onClick={openNewSocials}>
                                    <img src={IconPlus} alt='trash icon' />
                                </IconButton>

                            )}

                            <IconButton variant='plain' sx={{ height: '40px' }} onClick={() => deleteSocials(social.id, index)}>
                                <img src={IconTrash} alt='trash icon' />
                            </IconButton>


                            {!social.id ? (
                                <IconButton variant='plain' sx={{ height: '40px' }} onClick={() => checkCreateSocials(index)}>
                                    <CheckBoxIcon sx={{ color: '#3E64F4', fontSize: '35px' }} />
                                </IconButton>
                            ) : (
                                <IconButton variant='plain' sx={{ height: '40px' }} onClick={() => checkEditSocials(index)}>
                                    <EditIcon sx={{ background: '#185EA5', borderRadius: '50%', padding: '5px 5px', color: '#FFF' }} />
                                </IconButton>
                            )}
                        </Grid>
                    </Grid>
                )
            })}
        </>

    )
}